<mat-card>
  <form
    [formGroup]="templateInformationFormGroup"
    (ngSubmit)="
      templateInformationFormGroup.invalid || !fileName
        ? checkValidate()
        : saveDocumentTemplate()
    "
  >
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">
        <span *ngIf="mode === 'create'">{{
          "title.create_document_template_uppercase" | translate
        }}</span>
        <span *ngIf="mode === 'edit' || mode === 'draft'">{{
          "title.edit_document_template_uppercase" | translate
        }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mb-3 mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.general_information" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-group row">
            <div class="col-4">
              <!-- ma mau-->
              <mat-form-field class="w-100">
                <input
                  (focusout)="focusOut('code')"
                  matInput
                  type="text"
                  [placeholder]="
                    'document_template.lbl_code_template' | translate
                  "
                  name="code"
                  formControlName="code"
                  maxlength="50"
                  autocomplete="off"
                  required
                  #focusInput
                  [pattern]="documentCodePattern"
                  [readonly]="notPermission"
                />
                <button
                  mat-button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  *ngIf="isShowClearButton('code')"
                  (click)="clearData('code')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="templateInformationFormGroup.controls.code.invalid"
                >
                  <span *ngIf="isError('code', 'required')" class="text-error">
                    {{ "document_template.error_required_code" | translate }}
                  </span>
                  <span
                    *ngIf="
                      templateInformationFormGroup.get('code')?.errors?.pattern
                    "
                    class="text-error"
                  >
                    {{ "document_template.error_validate_code" | translate }}
                  </span>
                  <span
                    class="text-error"
                    *ngIf="
                      templateInformationFormGroup
                        .get('code')
                        .hasError('codeError')
                    "
                  >
                    {{ "document_template.check_code_exist" | translate }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-5">
              <!-- ten hop dong -->
              <mat-form-field class="w-100">
                <input
                  (focusout)="focusOut('name')"
                  matInput
                  type="text"
                  [placeholder]="
                    'document_template.lbl_name_template' | translate
                  "
                  name="documentName"
                  formControlName="name"
                  maxlength="200"
                  autocomplete="off"
                  required
                  [readonly]="notPermission"
                />
                <button
                  mat-button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  *ngIf="isShowClearButton('name')"
                  (click)="clearData('name')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="isError('name', 'required')">
                  {{ "document_template.error_required_name" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <!-- loai hop dong -->
              <mat-form-field class="w-100">
                <mat-select
                  [placeholder]="'document_template.lbl_type' | translate"
                  formControlName="type"
                  required
                  [disabled]="notPermission"
                  (selectionChange)="selectedChange($event)"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchTypeCtrl"
                      placeholderLabel="Nhập loại hợp đồng/văn bản"
                      [searching]="loadingSearchType"
                      noEntriesFoundLabel="Không có kết quả!"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let type of listTypes | async"
                    [value]="type?.id"
                    >{{ type?.name }}</mat-option
                  >
                </mat-select>
                <button
                  mat-button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  *ngIf="isShowClearButton('type')"
                  (click)="clearData('type')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="isError('type', 'required')">
                  {{ "document_template.eror_required_type" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12">
              <!-- mo ta -->
              <mat-form-field class="w-100">
                <textarea
                  (focusout)="focusOut('description')"
                  matInput
                  type="text"
                  [placeholder]="
                    'document_template.lbl_description_template' | translate
                  "
                  name="description"
                  formControlName="description"
                  maxlength="500"
                  autocomplete="off"
                  rows="2"
                  [readonly]="notPermission"
                ></textarea>
                <button
                  mat-button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  *ngIf="isShowClearButton('description')"
                  (click)="clearData('description')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mb-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.file_template_information" | translate }}
              <mat-icon
                class="custom-position-help-template-icon"
                matTooltip="{{
                  'title.file_template_information_tooltip' | translate
                }}"
              >
                info
              </mat-icon>
            </mat-panel-title>
            <!-- <span>{{ "title.file_template_information_note" | translate }}</span> -->
          </mat-expansion-panel-header>
          <div class="row pb-3">
            <div class="col-8">
              <div style="width: 90%">
                <span
                  >{{ "document_template.lbl_file_template" | translate }}
                  <span style="color: #fc1203">*</span></span
                >
                <span
                  style="color: #fc1203"
                  class="ml-1"
                  *ngIf="!fileIsError && requiredFileError"
                  >({{
                    "document_template.error_required_file" | translate
                  }})</span
                >
                <a
                  class="file-name"
                  *ngIf="fileName"
                  [class.error-file]="fileIsError"
                  style="cursor: pointer; word-break: break-word"
                  (click)="clickNameFile()"
                  [matTooltip]="
                    !fileIsError
                      ? ('document_template.tooltip_click_to_download'
                        | translate)
                      : ('document_template.tooltip_show_error' | translate)
                  "
                  >{{ fileName }}</a
                >
                <em
                  class="fa fa-exclamation-triangle icon vt-cursor-pointer ml-1"
                  style="color: #fc1203; cursor: pointer"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  (click)="onClickIconError()"
                  *ngIf="fileName && fileIsError"
                ></em>
                <button
                  class="btn btn-primary"
                  *ngIf="!fileName && !notPermission"
                  (click)="uploadFile()"
                  style="margin-left: 20px"
                  type="button"
                >
                  <mat-icon
                    class="mr-0"
                    style="vertical-align: bottom; width: auto; height: auto"
                    >cloud_upload</mat-icon
                  >
                  {{ "button.upload_file" | translate }}
                </button>
              </div>
              <div style="position: relative">
                <i>{{ "document_template.lbl_file_required" | translate }}</i>
                <mat-icon
                  matSuffix
                  matTooltip="{{
                    'enterprise_contract.panel_document.help_document_name.tooltip'
                      | translate
                  }}"
                  class="custom-position-help-template-icon"
                  style="vertical-align: middle"
                  (click)="
                    createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)
                  "
                >
                  help_outline
                </mat-icon>
                <ng-template #tplHelpTitle>
                  <span>{{
                    "document_template.help_document_template_form.modal_title"
                      | translate
                  }}</span>
                </ng-template>
                <ng-template #tplHelpContent>
                  <p>
                    <b>{{
                      "document_template.help_document_template_form.modal_content1"
                        | translate
                    }}</b>
                  </p>
                  <p>
                    {{
                      "document_template.help_document_template_form.modal_content2"
                        | translate
                    }}
                  </p>
                  <p>
                    <b>{{
                      "document_template.help_document_template_form.modal_content3"
                        | translate
                    }}</b>
                  </p>
                  <p>
                    {{
                      "document_template.help_document_template_form.modal_content4"
                        | translate
                    }}
                  </p>
                  <p>
                    {{
                      "document_template.help_document_template_form.modal_content5"
                        | translate
                    }}
                  </p>
                  <a href="/huong_dan_cau_hinh_mergefields_vcontract.pdf" target="_blank">{{
                    "document_template.help_document_template_form.modal_content6"
                      | translate
                  }}</a>
                </ng-template>
                <ng-template #tplHelpFooter>
                  <button
                    nz-button
                    nzType="primary"
                    (click)="destroyTplModal()"
                    class="ant-btn ant-btn-primary"
                  >
                    {{ "button.close" | translate }}
                  </button>
                </ng-template>
              </div>
            </div>
            <div
              class="col-4 text-right"
              style="position: relative; padding-right: 0.75rem"
            >
              <div class="d-flex justify-content-end">
                <input
                  type="file"
                  id="file"
                  name="file"
                  style="display: none"
                  (change)="onChangeFile($event)"
                  accept=".docx"
                  onclick="this.value = null"
                />
                <button
                  class="mr-2 custom-button-icon"
                  mat-stroked-button
                  color="primary"
                  *ngIf="fileName"
                  (click)="uploadFile()"
                  type="button"
                  [matTooltip]="'button.change_file' | translate"
                >
                  <mat-icon
                    class="mr-0"
                    style="vertical-align: middle; width: auto; height: auto"
                    >swap_horiz</mat-icon
                  >
                  <!-- <mat-icon>restore_page</mat-icon> -->
                  <!-- {{ "button.change_file" | translate }} -->
                </button>
                <button
                  class="mr-2 custom-button-icon"
                  mat-stroked-button
                  color="primary"
                  *ngIf="fileName"
                  (click)="previewFile()"
                  [disabled]="fileIsError"
                  type="button"
                  [matTooltip]="'button.preview_template_file' | translate"
                >
                  <mat-icon
                    class="mr-0"
                    style="vertical-align: middle; width: auto; height: auto"
                    >visibility</mat-icon
                  >
                  <!-- {{ "button.preview_template_file" | translate }} -->
                </button>
                <button
                  class="mr-2 custom-button-icon"
                  mat-stroked-button
                  color="primary"
                  *ngIf="fileName"
                  (click)="getMergeField()"
                  [disabled]="fileIsError"
                  type="button"
                  [matTooltip]="'button.get_merge_field' | translate"
                >
                  <!-- <mat-icon>library_add</mat-icon> -->
                  <mat-icon
                    class="mr-0"
                    style="vertical-align: middle; width: auto; height: auto"
                    >publish</mat-icon
                  >
                  <!-- {{ "button.get_merge_field" | translate }} -->
                </button>
                <button
                  class="mr-2 custom-button-icon"
                  mat-stroked-button
                  color="primary"
                  *ngIf="fileName"
                  (click)="onClickReset()"
                  [disabled]="fileIsError"
                  type="button"
                  [matTooltip]="'button.reset_merge_field' | translate"
                >
                  <mat-icon
                    class="mr-0"
                    style="vertical-align: middle; width: auto; height: auto"
                    >cached</mat-icon
                  >
                  <!-- {{ "button.reset_merge_field" | translate }} -->
                </button>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mb-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.settings_template" | translate }}
              <mat-icon
                class="custom-position-help-template-icon"
                matTooltip="{{ 'title.settings_template_tooltip' | translate }}"
              >
                info
              </mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-tab-group [selectedIndex]="selectedIndex">
            <mat-tab [label]="'title.settings_template_content' | translate">
              <app-field-config
                (difference_process)="displayProcessButton($event)"
                (dataNameField)="getNameField($event)"
                (dataGroupField)="getGroupField($event)"
                (moveBtnDisplay)="isMoveBtnDisplay($event)"
                (displayBtnForm)="isDisplayBtnForm($event)"
                [dataRowForMove]="dataRow"
                [dataRowForGroup]="dataGroup"
                [listSignatureConfigCustomer]="listSignatureConfigCustomer"
                [template_id]="templateId"
                [notPermission]="notPermission"
                (clickDialogMergeField)="isDialogMergeFieldClick($event)"
                #fieldConfig
              ></app-field-config>
            </mat-tab>
            <mat-tab [label]="'title.settings_footnote' | translate">
              <app-signature-config
                [dataSignatureConfig]="listSignatureConfig"
                [template_id]="templateId"
                [enterpriseSign]="enterpriseSign"
                (signatureConfigSaved)="updateSignatureConfigCustomer()"
              ></app-signature-config>
            </mat-tab>
            <mat-tab [label]="'title.config_signing_flow_uint' | translate">
              <app-configuring-signin-flow
                [configFlowSignList]="configFlowSignList"
                [selectedServiceType]="selectedServiceType"
                (configFlowSignListChange)="configFlowSignListChange($event)"
                [isDraft]="isDraft"
              ></app-configuring-signin-flow>
            </mat-tab>
          </mat-tab-group>
        </mat-expansion-panel>
      </mat-accordion>
      <div
        class="pr-0 fixed-bottom"
        *ngIf="!disableButtonForm && !notPermission"
      >
        <div class="bg-white text-center mat-elevation-z0 py-2 w-100">
          <button
            mat-stroked-button
            color="primary"
            class="mr-3"
            type="button"
            (click)="cancel()"
          >
            <mat-icon class="mr-0">cancel</mat-icon
            >{{ "button.cancel" | translate }}
          </button>
          <button
            mat-stroked-button
            color="primary"
            class="mr-3"
            (click)="onClickClearDraft()"
            *ngIf="mode === 'draft'"
            type="button"
          >
            <i
              class="fa fa-trash"
              style="font-size: 20px"
              aria-hidden="true"
            ></i>
            {{ "button.clear_draft" | translate }}
          </button>
          <button mat-raised-button color="primary" type="submit">
            <mat-icon class="mr-0">save</mat-icon
            ><span *ngIf="mode === 'edit' || mode === 'draft'">{{
              "button.update" | translate
            }}</span>
            <span *ngIf="mode === 'create'">{{
              "button.add" | translate
            }}</span>
          </button>
        </div>
      </div>
    </mat-card-content>
  </form>
</mat-card>
